// Stable, locale-independent values. "today"/"yesterday" are sentinels that
// components translate at display time; any other value is an already
// locale-formatted date string shown as-is.
export const INGESTION_TODAY = "today";
export const INGESTION_YESTERDAY = "yesterday";
export type IngestionDate =
  typeof INGESTION_TODAY | typeof INGESTION_YESTERDAY | string;

export interface IngestionDateTime {
  dateTimestamp: number;
  dateLabel: IngestionDate;
  timeLabel: string;
}

export interface IngestionEntry {
  entityType: string;
  ingestedAt: IngestionDateTime | null;
  noEntryReason?: string;
}

export interface IngestionEntriesState {
  entries: IngestionEntry[] | null;
  failed: boolean;
}
